import React from 'react'
import SettingsContent from '../../components/SettingsContent'
import {ContentBox, NavBox, WrappedBox} from '../../styles/global'
import Sidenav from '../../new-dashboard/components/Sidenav'

const View = () => {
  return (
    <WrappedBox>
      <NavBox>
        <Sidenav />
      </NavBox>
      <ContentBox>
        <SettingsContent />
      </ContentBox>
    </WrappedBox>
  )
}

export default View
